/**
 * <BrandLogo> — shared Iris Security branding.
 *
 * Two variants:
 *   `variant="full"` — horizontal logo with the "IRIS SECURITY" wordmark.
 *                      Use in wide contexts: Login, Signup, expanded sidebars.
 *   `variant="icon"` — just the hexagonal mark. Use in compact contexts:
 *                      collapsed sidebar, favicon, small square badges.
 *
 * Sizes controlled via `height` (px). Full logo scales width automatically.
 */
export const BRAND_LOGO_FULL = "https://customer-assets.emergentagent.com/job_guard-track-5/artifacts/pev84e01_Iris%20Real%20logo%20PNG%202-2.png";
export const BRAND_LOGO_ICON = "https://customer-assets.emergentagent.com/job_guard-track-5/artifacts/z769re44_Iris%20Real%20logo%20fav.png";

export function BrandLogo({ variant = "icon", height = 32, className = "", alt = "Iris Security" }) {
  const src = variant === "full" ? BRAND_LOGO_FULL : BRAND_LOGO_ICON;
  return (
    <img
      src={src}
      alt={alt}
      style={{ height, width: "auto" }}
      className={`shrink-0 ${className}`}
      draggable={false}
    />
  );
}
